import { stepVehiclePhysics, type VehicleInput, type VehicleState } from './vehicle';
import { resolveVehicleCollisions } from './collision';

/**
 * One ground frame: velocity integration in `stepVehiclePhysics`, then position + wall collision.
 * Shared by GameView (single-player), prediction replay, and the multiplayer server.
 */
export function integrateGroundStep(
  vehicle: VehicleState,
  input: VehicleInput,
  dt: number,
): void {
  stepVehiclePhysics(vehicle, input, dt);
  const xTry = vehicle.x + vehicle.vx * dt;
  const zTry = vehicle.z + vehicle.vz * dt;
  const preVx = vehicle.vx;
  const preVz = vehicle.vz;
  const fixed = resolveVehicleCollisions(xTry, zTry, preVx, preVz);
  vehicle.x = fixed.x;
  vehicle.z = fixed.z;
  vehicle.vx = fixed.vx;
  vehicle.vz = fixed.vz;
}
